module.exports = __webpack_public_path__ + "static/img/gzh.d32197c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzh.jpg
// module id = d5S/
// module chunks = 1